import React from 'react'
import { useForm, useFormState } from 'react-final-form'
import { Form, Segment, Message, Button } from 'semantic-ui-react'
import { ProductLocalizedKeys } from '../form/types'
import { Details } from './Details'
import { Images } from './Images'

export const EditLocalizationForm = ({
  product,
  actions: Actions = DefaultActions,
}: {
  product: ProductLocalizedKeys
  actions?: React.FC
}) => {
  const { submit } = useForm()
  const { submitError } = useFormState()

  return (
    <Form onSubmit={submit} error={!!submitError}>
      <Segment attached style={{ borderTop: 'none' }}>
        <Details product={product} />
        <Images product={product} />

        {submitError && <Message error header={submitError.name} content={submitError.message} />}
      </Segment>

      <Segment attached textAlign="right">
        <Actions />
      </Segment>
    </Form>
  )
}

const DefaultActions = () => {
  const { submitting, pristine } = useFormState()
  return (
    <Button type="submit" primary disabled={submitting || pristine}>
      Save
    </Button>
  )
}
